import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import { Link } from "react-router-dom";
import SubMenu from "./SubMenu";
import SubMenuThuongDung from "./SubMenuThuongDung";
import logo from "Resources/ImagesNew/logo.png";
import avataMacDinh from "Resources/ImagesNew/avata/daily.png";
import { SidebarDataChucNang } from "./SidebarDataChucNang";
import { SidebarAccount } from "./SidebarAccount";
import { getUserLogin } from "../../utils/utils";
import arrow from "Resources/ImagesNew/Dropdown.png";
import arrowUp from "Resources/ImagesNew/DropdownUp.png";
import verified from "Resources/ImagesNew/verified_black_24dp.png";
import Ellipse1 from "Resources/ImagesNew/Ellipse1.png";
import icon_cart from "Resources/ImagesNew/Icon/icon_cart.png";
import iconNXT from "Resources/ImagesNew/Icon/iconNXT.png";
import { getUrl } from "utils/utils";
import { getPhienBan } from "utils/utils";
import { getDomain } from "utils/utils";
import { Index_GetConfigAllSTKey } from "actions/DanhMuc/";
import configs from "../../constants/configs";
import { Cookies } from "react-cookie";
import PhanQuyenApi from "service/HeThongNT/PhanQuyenApi";
const Nav = styled.div`
  background: #ffffff;
  padding: 0 24px;
  -webkit-box-shadow: 0 0 35px 0 rgb(154 161 171 / 15%);
  box-shadow: 0 0 35px 0 rgb(154 161 171 / 15%);
  min-height: 60px;
  position: fixed;
  left: 260px;
  top: 0;
  right: 0;
  z-index: 1001;
`;

const NavIcon = styled(Link)`
  margin-left: 2rem;
  font-size: 2rem;
  height: 80px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const SidebarNav = styled.nav`
  background: #02499b;
  width: 260px;
  height: 100vh;
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  left: ${({ sidebar }) => (sidebar ? "0" : "-100%")};
  transition: margin-left 0.3s ease-in-out, left 0.3s ease-in-out,
    margin-right 0.3s ease-in-out, right 0.3s ease-in-out;
  transition: 350ms;
  z-index: 10;
`;

const SidebarWrap = styled.div`
  width: 100%;
`;

const SidebarBrand = styled.div`
  background: #02499b;
  color: #212529;
  display: block;
  font-size: 1.175rem;
  font-weight: 500;
  padding: 1rem;
  text-decoration: none;
  width: 100%;
`;
const SidebarUser = styled.div`
  color: #153d77;
  padding: 15px 10px;
  text-align: center;
  display: flex;
`;
const AdminInfo = styled.div`
  padding-left: 1rem;
  color: #fff;
  text-align: left;
`;
const SidebarLabel = styled.span`
  margin-left: 16px;
`;
const Sidebar = ({ sidebar }) => {
  return (
    <>
      <div
        className={`SidebarNav ${sidebar ? "" : "toggled"}`}
        sidebar={sidebar}
      >
        <SidebarWrap>
          <SidebarBrand>
            <img src={logo} alt="" width="auto" height="37" />
          </SidebarBrand>
          <SidebarUser>
            <div className="avatar-md">
              <img
                src={avataMacDinh}
                class="avatar-img"
                alt=""
                style={{ minWidth: "40px" }}
              ></img>
            </div>

            <AdminInfo>
              <div className="text-useName-new">{getUserLogin().FullName}</div>
              <small className="text-body-user">
                {getUserLogin().UserName}
              </small>
            </AdminInfo>
          </SidebarUser>
          <div className="title-menu-new" style={{ paddingTop: "20px" }}>Chức năng</div>
          <a className="SidebarLink" href="/DatHang">
            <div>
              <img src={icon_cart} className="icon-menu-new"></img>
              <SidebarLabel>{"Đặt hàng"}</SidebarLabel>
            </div>
          </a>
          <a className="SidebarLink" href="/DanhSachDatHang" >
            <div>
              <img src={iconNXT} className="icon-menu-new"></img>
              <SidebarLabel>{"Danh sách đặt hàng"}</SidebarLabel>
            </div>
          </a>
          <a className="SidebarLink" href="/DanhSachDonHang"   >
            <div>
              <img src={iconNXT} className="icon-menu-new"></img>
              <SidebarLabel>{"Danh sách đơn hàng"}</SidebarLabel>
            </div>
          </a>
          <hr className="line-menu-new" />
          {SidebarAccount.map((item, index) => {
            return <SubMenu item={item} key={index} />;
          })}
        </SidebarWrap>
      </div>
    </>
  );
};

export default Sidebar;
